import { render } from "./CalendarHost.vue?vue&type=template&id=63495497"
import script from "./CalendarHost.vue?vue&type=script&lang=ts"
export * from "./CalendarHost.vue?vue&type=script&lang=ts"
script.render = render

export default script